import React from 'react';
import styled from 'styled-components';

import { GrabHandleProps } from './types';

import { colors } from '@controlrooms/design-tokens';

// Styled Components
const Container = styled.div<{ $interactive?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  padding: 4px 8px;
  border-top: 1px solid ${colors.container['b-g-5']};

  ${({ $interactive }) =>
    $interactive &&
    `
    cursor: ns-resize;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  `}
`;

const Handle = styled.div<{ $hover?: boolean }>`
  width: 100%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 100px;
  transition: background-color 0.2s ease;

  ${({ $hover }) =>
    $hover &&
    `
    background-color: rgba(0, 0, 0, 0.25);
  `}
`;

// Component
export const GrabHandle: React.FC<GrabHandleProps> = ({
  hover = false,
  className,
  style,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
}) => {
  const isInteractive = !!(onMouseDown || onMouseEnter || onMouseLeave);

  return (
    <Container
      className={className}
      style={style}
      $interactive={isInteractive}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Handle $hover={hover} />
    </Container>
  );
};
